import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { AuthProvider } from '@/contexts/AuthContext'
import { ToastProvider } from '@/contexts/ToastContext'
import { ProfileProvider } from '@/contexts/ProfileContext'
import { NotificationProvider } from '@/contexts/NotificationContext'
import { PrivateRoute } from '@/components/PrivateRoute'
import {
  HomePage,
  AdminCreateRoomPage,
  AdminEditRoomPage,
  LoginPage,
  ProfileRegisterPage,
  ProfileEditPage,
  ProfileConfirmPage,
  RoomPage,
  ChatPage,
  ProfileDetailPage,
  RoomQrEntryPage,
  SubInfoEditPage,
  SubInfoEditFormPage,
} from '@/pages'
import { theme } from '@/config/theme'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <ToastProvider>
          <AuthProvider>
            <ProfileProvider>
            <NotificationProvider>
            <Routes>
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <HomePage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/room/create"
                element={
                  <PrivateRoute requireAdmin>
                    <AdminCreateRoomPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/room/edit/:roomId"
                element={
                  <PrivateRoute requireAdmin>
                    <AdminEditRoomPage />
                  </PrivateRoute>
                }
              />
              <Route path="/login" element={<LoginPage />} />
              {/* メール/パスワード登録は無効。
                  ログイン画面はGoogleログインのみを提供しており、この画面で
                  登録してもログインする手段が無い。加えて登録時にバックエンドの
                  ユーザー作成を行わないため、DBにレコードが無い状態になり
                  以降のAPI呼び出しがすべて失敗する。
                  メール認証を再開する場合はログイン手段とDB登録をセットで実装すること。 */}
              <Route path="/register" element={<Navigate to="/login" replace />} />
              {/* QR入室フローは未ログインから開始するため認証ガードを掛けない
                  （フロー内の Step0 で Google 認証を行う） */}
              <Route path="/room/:roomId/qr-entry" element={<RoomQrEntryPage />} />
              <Route
                path="/profile/register"
                element={
                  <PrivateRoute>
                    <ProfileRegisterPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile/edit"
                element={
                  <PrivateRoute>
                    <ProfileEditPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile/confirm"
                element={
                  <PrivateRoute>
                    <ProfileConfirmPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/room/:roomId"
                element={
                  <PrivateRoute>
                    <RoomPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/chat/:chatId"
                element={
                  <PrivateRoute>
                    <ChatPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile/:profileId"
                element={
                  <PrivateRoute>
                    <ProfileDetailPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/sub-info/edit"
                element={
                  <PrivateRoute>
                    <SubInfoEditPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/sub-info/edit/:roomId"
                element={
                  <PrivateRoute>
                    <SubInfoEditFormPage />
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </NotificationProvider>
            </ProfileProvider>
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
